import { FormRule } from "antd";
import {
  onlyLatinCharsDigitsRule,
  onlyLatinCharsDigitsSpecialSymbolsRule,
  onlyUppercaseNumbers,
} from "../utils/form.constants";

export const companyNameRules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: "Please enter name",
    validateTrigger: "onBlur",
    whitespace: true,
  },
  {
    min: 3,
    message: "Minimum 3 characters",
    validateTrigger: "onBlur",
  },
  {
    max: 256,
    message: "Maximum 256 characters",
    validateTrigger: "onBlur",
  },
];
export const companyFullNameRules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: "Please enter full name",
    validateTrigger: "onBlur",
    whitespace: true,
  },
  {
    min: 3,
    message: "Minimum 3 characters",
    validateTrigger: "onBlur",
  },
  {
    max: 256,
    message: "Maximum 256 characters",
    validateTrigger: "onBlur",
  },
];
export const companyCountryRules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: "Please enter country",
    validateTrigger: "onBlur",
    whitespace: true,
  },
  {
    min: 2,
    message: "Minimum 2 characters",
    validateTrigger: "onBlur",
  },
  {
    max: 50,
    message: "Maximum 50 characters",
    validateTrigger: "onBlur",
  },
];
export const companyAddress1Rules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: "Please enter address 1",
    validateTrigger: "onBlur",
    whitespace: true,
  },
  {
    max: 256,
    message: "Maximum 256 characters",
    validateTrigger: "onBlur",
  },
];
export const companyAddress2Rules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    max: 256,
    message: "Maximum 256 characters",
    validateTrigger: "onBlur",
  },
];
const companyTinVatUidBasicRules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    min: 4,
    message: "Minimum 4 characters",
    validateTrigger: "onBlur",
  },
  {
    max: 20,
    message: "Maximum 20 characters",
    validateTrigger: "onBlur",
  },
];
export const companyDirectorsFirstNameRules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: "Director's first name is required",
    validateTrigger: "onBlur",
    whitespace: true,
  },
];
export const companyDirectorsLastNameRules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: "Director's last name is required",
    validateTrigger: "onBlur",
    whitespace: true,
  },
];
export const companyCityRules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: "City is required",
    validateTrigger: "onBlur",
    whitespace: true,
  },
];
export const companyPostalCodeRules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: "Postal Code is required",
    validateTrigger: "onBlur",
    whitespace: true,
  },
];
export const companyStateProvinceRules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: "State/Province is required",
    validateTrigger: "onBlur",
    whitespace: true,
  },
];
export const companyTinRules: FormRule[] = [
  ...companyTinVatUidBasicRules,
  {
    required: true,
    message: "Please enter TIN",
    validateTrigger: "onBlur",
    whitespace: true,
  },
];
export const companyTinVatUidRules: FormRule[] = [
  ...companyTinVatUidBasicRules,
  {
    required: true,
    message: "Please enter VAT/TIN/UID",
    validateTrigger: "onBlur",
    whitespace: true,
  },
];
export const companyRegistrationNumberRules: FormRule[] = [
  {
    pattern: /^[A-Z0-9\-_.]*$/,
    message:
      "Only uppercase letters, numbers, and characters - _ . are allowed",
    validateTrigger: "onBlur",
  },
  {
    required: true,
    message: "This field is required",
    validateTrigger: "onBlur",
  },
  {
    min: 4,
    message: "Minimum 4 characters",
    validateTrigger: "onBlur",
  },
  {
    max: 20,
    message: "Maximum 20 characters",
    validateTrigger: "onBlur",
  },
];
export const companyTelRules: FormRule[] = [
  {
    min: 6,
    message: 'Minimum 6 characters',
    validateTrigger: 'onBlur',
  },
  {
    max: 21,
    message: 'Maximum 21 characters',
    validateTrigger: 'onBlur',
  },
];
export const companyTelRules2: FormRule[] = [
  {
    min: 6,
    message: 'Minimum 6 characters',
    validateTrigger: 'onBlur',
  },
  {
    max: 21,
    message: 'Maximum 21 characters',
    validateTrigger: 'onBlur',
  },
];
export const companyEmailRules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    type: "email",
    message: "Invalid email address",
    validateTrigger: "onBlur",
  },
  {
    required: true,
    message: "Please enter email address",
    validateTrigger: "onBlur",
  },
  {
    max: 256,
    message: "Maximum 256 characters",
    validateTrigger: "onBlur",
  },
];
